import { useCallback } from "react";
import BannerImage from "@/components/BannerImage/BannerImage";
import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxBannerPanel = ({ dashboard, flex }: FundDetailLayoutComponentProps) => {
	const { fxBannerPanel: props } = dashboard;

	const openLinkOnClick = useCallback((link: string) => {
		return () => {
			return window.open(link, "_blank");
		};
	}, []);

	if (!props) {
		return null;
	}

	return (
		<ContentBlock
			id="fxBannerPanel"
			onClick={props.link ? openLinkOnClick(props.link) : undefined}
			data-testid="FxBannerPanel"
			flex={flex}
			cursor={props.link ? "pointer" : "inherit"}
			tabIndex={-1}
		>
			<BannerImage {...props} />
		</ContentBlock>
	);
};
